import { num, batteryText, positionText } from "@/lib/format";
import { courseLabel } from "@/lib/mapNavigation";
import { DroneHealthMini } from "@/components/RaspberryHealth";
import { NetworkStatusWidget } from "@/components/NetworkStatusWidget";

// SKYCORE MAP.NAV.3 — contenu de la popup drone (dernières valeurs disponibles). Une valeur absente,
// périmée ou une position invalide n'est jamais présentée comme une mesure valide.
const GPS_LABEL = { FIX: "OK", NO_FIX: "NON", UNKNOWN: "INCONNU" };
const FRESH_LABEL = { FRESH: "À JOUR", STALE: "PÉRIMÉE", UNKNOWN: "INCONNUE", REPLAY: "RELECTURE" };

function Row({ id, label, children }) {
  return <div data-testid={id}>{label}: {children}</div>;
}

export default function DronePopupContent({ d, nav, showHealth }) {
  const stale = nav.freshness !== "FRESH";
  const id = d.drone_id;
  const alt = d.relative_alt != null ? d.relative_alt : d.alt;
  return (
    <div data-testid={`drone-popup-${id}`} data-freshness={nav.freshness} data-position-valid={nav.positionValid ? "1" : "0"}
      className="drone-popup font-mono text-xs space-y-0.5">
      <div className="font-bold text-sm pr-5">{id}</div>
      {!nav.positionValid && <div data-testid={`drone-popup-pos-warning-${id}`} className="text-[#F59E0B]">POSITION INVALIDE — dernière position connue affichée</div>}
      {stale && <div data-testid={`drone-popup-stale-${id}`} className="text-[#F59E0B]">TÉLÉMÉTRIE {FRESH_LABEL[nav.freshness]}</div>}
      <div className={stale ? "opacity-60" : ""}>
        <Row id={`drone-popup-battery-${id}`} label="Batterie">{batteryText(d)}</Row>
        <Row id={`drone-popup-position-${id}`} label="Position">{nav.positionValid ? `${num(nav.lat, 5)}, ${num(nav.lng, 5)}` : positionText(d)}</Row>
        <Row id={`drone-popup-alt-${id}`} label="Altitude">{alt != null ? `${num(alt)} m` : "—"}</Row>
        <Row id={`drone-popup-speed-${id}`} label="Vitesse">{nav.speedMps != null ? `${num(nav.speedMps)} m/s` : "—"}</Row>
        <Row id={`drone-popup-mode-${id}`} label="Mode">{d.mode || "—"}</Row>
        <Row id={`drone-popup-gps-${id}`} label="GPS">{GPS_LABEL[nav.gps] || "INCONNU"}</Row>
        <Row id={`drone-popup-heading-${id}`} label="Cap">{nav.headingValid ? `${num(nav.headingDeg, 0)}°` : "indisponible"}</Row>
        <Row id={`map-popup-course-${id}`} label="Déplacement">{nav.courseValid ? `${num(nav.courseDeg, 0)}° (${courseLabel(nav)})` : "—"}</Row>
        <Row id={`drone-popup-status-${id}`} label="Statut">{d.status || "—"}</Row>
        <Row id={`drone-popup-freshness-${id}`} label="Télémétrie">{FRESH_LABEL[nav.freshness]}</Row>
      </div>
      {showHealth && <DroneHealthMini droneId={id} />}
      {showHealth && <NetworkStatusWidget droneId={id} variant="mini" interval={12000} />}
    </div>
  );
}
